/* eslint-disable max-len */
import React from 'react';

const ContextMenuIcon = (props: $TSFixMe) => (
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="context-menu-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="01-Foundation-/-Icon-Medium-24-(Default)-/-01-Actions-/-09-More-Copy-4"
        fill="#000000"
        transform="translate(10.000000, 10.000000) rotate(-180.000000) translate(-10.000000, -10.000000) "
      >
        <path
          d="M6.25,9.16666667 C6.89720869,9.16666667 7.4295339,9.65431112 7.49354639,10.2880683 L7.5,10.4166667 C7.5,11.0638754 7.01235554,11.5962006 6.3785984,11.6602131 L6.25,11.6666667 C5.55964406,11.6666667 5,11.1118356 5,10.4166667 C5,9.76945798 5.48764446,9.23713277 6.1214016,9.17312028 L6.25,9.16666667 Z M10.4166667,9.16666667 C11.0638754,9.16666667 11.5962006,9.65431112 11.6602131,10.2880683 L11.6666667,10.4166667 C11.6666667,11.0638754 11.1790222,11.5962006 10.5452651,11.6602131 L10.4166667,11.6666667 C9.72631073,11.6666667 9.16666667,11.1118356 9.16666667,10.4166667 C9.16666667,9.76945798 9.65431112,9.23713277 10.2880683,9.17312028 L10.4166667,9.16666667 Z M14.5833333,9.16666667 C15.230542,9.16666667 15.7628672,9.65431112 15.8268797,10.2880683 L15.8333333,10.4166667 C15.8333333,11.0638754 15.3456889,11.5962006 14.7119317,11.6602131 L14.5833333,11.6666667 C13.8929774,11.6666667 13.3333333,11.1118356 13.3333333,10.4166667 C13.3333333,9.76945798 13.8209778,9.23713277 14.4547349,9.17312028 L14.5833333,9.16666667 Z"
          id="Color"
        />
      </g>
    </g>
  </svg>
);

export default ContextMenuIcon;
